/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserIdentityProvider {
    Unknown = 'Unknown',
    IdPorten = 'IdPorten',
    Statsforvalteren = 'Statsforvalteren',
    Miljodirektoratet = 'Miljodirektoratet'
}


export function instanceOfUserIdentityProvider(value: any): boolean {
    for (const key in UserIdentityProvider) {
        if (Object.prototype.hasOwnProperty.call(UserIdentityProvider, key)) {
            if (UserIdentityProvider[key as keyof typeof UserIdentityProvider] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserIdentityProviderFromJSON(json: any): UserIdentityProvider {
    return UserIdentityProviderFromJSONTyped(json, false);
}

export function UserIdentityProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdentityProvider {
    return json as UserIdentityProvider;
}

export function UserIdentityProviderToJSON(value?: UserIdentityProvider | null): any {
    return value as any;
}

export function UserIdentityProviderToJSONTyped(value: any, ignoreDiscriminator: boolean): UserIdentityProvider {
    return value as UserIdentityProvider;
}

